import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import {
  booleanAttribute,
  Component,
  input,
  model,
  signal,
} from '@angular/core';
import { DatePicker } from '../date-picker/date-picker.component';
import { PickCalendar } from '../date-picker/pick-calendar/pick-calendar.component';

@Component({
  selector: 'lepi-date-range',
  templateUrl: './date-range.component.html',
  imports: [DatePicker, PickCalendar, OverlayModule],
})
export class DateRange {
  label = input<string>('');
  required = input<boolean, string>(false, { transform: booleanAttribute });

  startAt = model<Date>();
  endAt = model<Date>();

  overlayPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  ];

  // 임시 선택 상태 (Apply 버튼 클릭 전까지 유지)
  tempStartAt = signal<Date | undefined>(undefined);
  tempEndAt = signal<Date | undefined>(undefined);

  isOpen = signal(false);

  openOverlay() {
    this.tempStartAt.set(this.startAt());
    this.tempEndAt.set(this.endAt());
    this.isOpen.set(true);
  }

  handleApply() {
    this.startAt.set(this.tempStartAt());
    this.endAt.set(this.tempEndAt());
    this.isOpen.set(false);
  }

  handleCancel() {
    this.isOpen.set(false);
  }
}
